import { CalendarClock, CircleAlert, Clock3, Globe, Hourglass } from 'lucide-react';
import { DATE_BASIS_LABEL } from 'modules/arena/reports/model/areas';
import { formatDate, formatPeriod, formatTimestamp } from 'modules/arena/reports/model/dates';
import { ReportMeta } from 'modules/arena/reports/model/types';

// Contexto do que está na tela: período, data-base, referência, atualização e fuso.
export function ReportMetaBar({ meta }: { meta: ReportMeta }) {
  return (
    <div className="flex flex-col gap-2">
      <dl className="flex flex-wrap gap-x-5 gap-y-1.5 text-xs text-ink-secondary">
        <div className="flex items-center gap-1.5">
          <CalendarClock className="h-3.5 w-3.5" aria-hidden="true" />
          <dt>Período:</dt>
          <dd className="font-medium text-ink">{formatPeriod(meta.period.start, meta.period.end)}</dd>
        </div>
        {meta.previousPeriod && (
          <div className="flex items-center gap-1.5">
            <dt>Comparado com:</dt>
            <dd className="font-medium text-ink">{formatPeriod(meta.previousPeriod.start, meta.previousPeriod.end)}</dd>
          </div>
        )}
        <div className="flex items-center gap-1.5">
          <dt>Data-base:</dt>
          <dd className="font-medium text-ink">{DATE_BASIS_LABEL[meta.dateBasis]}</dd>
        </div>
        <div className="flex items-center gap-1.5">
          <dt>Data de referência:</dt>
          <dd className="font-medium text-ink">{formatDate(meta.referenceDate)}</dd>
        </div>
        <div className="flex items-center gap-1.5">
          <Clock3 className="h-3.5 w-3.5" aria-hidden="true" />
          <dt>Atualizado em:</dt>
          <dd className="font-medium text-ink">{formatTimestamp(meta.updatedAt, meta.timezone)}</dd>
        </div>
        <div className="flex items-center gap-1.5">
          <Globe className="h-3.5 w-3.5" aria-hidden="true" />
          <dt>Fuso:</dt>
          <dd className="font-medium text-ink">{meta.timezone.replace('_', ' ')}</dd>
        </div>
      </dl>

      {meta.inProgress && (
        <p className="flex items-center gap-1.5 text-xs text-ink-secondary">
          <Hourglass className="h-3.5 w-3.5 text-primary-dark" aria-hidden="true" />
          O período inclui hoje e ainda está em andamento: os números podem mudar até o fim do dia.
        </p>
      )}
      {meta.partial && (
        <p role="status" className="flex items-start gap-2 rounded-lg border border-warning/40 bg-warning-soft px-3 py-2 text-sm text-ink">
          <CircleAlert className="mt-0.5 h-4 w-4 flex-shrink-0 text-warning" aria-hidden="true" />
          <span>
            <strong className="font-semibold">Dados parciais.</strong> {meta.partial.message}
          </span>
        </p>
      )}
    </div>
  );
}
